module.exports = __webpack_public_path__ + "static/media/OCS_New_Logo_with_Texts_no_motto.3573788b.jpg";